"use client";
import React, { useState, useEffect } from "react";
import { Dealer } from "../../lib/excelToJson"
import DealerCard from "./DealerCard";
import { DealerCardSkeleton } from "../Common/Skeleton";

const Dealers = () => {
	const [dealers, setDealers] = useState<Dealer[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchDealers = async () => {
			try {
				setLoading(true);
				setError(null);
				const response = await fetch('https://saintiant-precision-5860-tower.tail6bd07e.ts.net/middleware/dealers');
				if (!response.ok) {
					throw new Error(`Failed to fetch dealers: ${response.status}`);
				}
				const data = await response.json();
				if (!Array.isArray(data)) {
					throw new Error("Expected array from dealers API");
				}
				setDealers(data);
			} catch (err) {
				console.error("Error fetching dealers:", err);
				setError(err instanceof Error ? err.message : "Failed to load dealers");
				setDealers([]);
			} finally {
				setLoading(false);
			}
		};

		fetchDealers();
	}, []);
	if (loading) {
		return (
			<section id="about" className="mx-4 mt-10 md:mx-10 md:mt-20 lg:mt-2">
				<div className="flex flex-col md:flex-row min-h-screen">
					<div className="w-full md:w-1/2 p-10 space-y-4">
						{[1,2,3].map(i=> <DealerCardSkeleton key={i}/>)}
					</div>
				</div>
			</section>
		);
	}

	if (error) {
		return (
			<section id="about" className="mx-4 mt-10 md:mx-10 md:mt-20 lg:mt-2">
				<div className="p-10 text-center text-slate-500">
					<p>{error}</p>
					<p className="mt-2 text-sm">Please try again later.</p>
				</div>
			</section>
		);
	}

	return (
		<section id="about" className="mx-4 mt-10 md:mx-10 md:mt-20 lg:mt-2">
		  <div className="flex flex-col md:flex-row min-h-screen">
			<div className="w-full md:w-1/2 p-10 space-y-4">
			  {/* Convert Set to an array before iterating - guarded */}
			  {Array.isArray(dealers) && dealers.length > 0 ? (
				Array.from(new Set(dealers.map((dealer) => dealer.country))).map((country) => (
				<div key={country}>
				  <h1 className="ml-4 mb-4 text-5xl font-bold">{country}</h1>
				  {Array.isArray(dealers) && dealers.length > 0 && dealers
					.filter((dealer) => dealer.country === country)
					.sort((a, b) => a.name.localeCompare(b.name)) // Sorting dealers by name
					.map((dealer) => (
					  <div key={dealer.id}>
						<div style={{ marginBottom: "10px" }}></div>
						<DealerCard dealer={dealer} />
					  </div>
					))}
				</div>
			  ))
			  ) : (
				<div className="text-center text-slate-500 py-10">No dealers available</div>
			  )}
			</div>
		  </div>
		</section>
	  );
};

export default Dealers;

